// extracted by mini-css-extract-plugin
export default {"close":"index_close_Pqq-h","num":"index_num_5mB3J","current":"index_current_qUujJ","total":"index_total_31ob3"};